import { get, values, map, find, compact, orderBy, keys, sortBy, intersection, isEqual, forIn } from 'lodash'
import { createSelector } from 'reselect'

import { getRevenueCenters } from '../RevenueCenter/selector'
import { getDefaultPreferences } from '../CustomerOrderingPreference/selector'
import { getSelectedSuites, makeGetDisplaySuite } from '../../store/Suite/selector'

export const getCustomers = state => values(get(state, 'customer.byId'))

const getCustomer = (state, customerId) => get(state, `customer.byId.${customerId}`, {})

export const makeGetCustomer = () => createSelector([getCustomer], (customer) => customer)

export const getCustomersAndAssignedSuites = createSelector(
  [getCustomers, getRevenueCenters, getDefaultPreferences],
  (customers, revenueCenters, defaultPreferences) => {
    const result = map(customers, (customer) => {
      const suiteIds = keys(defaultPreferences[customer.uuid])
      const customerSuites = map(suiteIds, (suiteId) => {
        return find(revenueCenters, ['uuid', suiteId])
      })

      const sortedCustomerSuites = sortBy(compact(customerSuites), (suite) => suite.name)

      return {
        ...customer,
        suites: sortedCustomerSuites,
      }
    })

    return orderBy(result, 'name')
  }
)

export const getCustomerDefaultPreferences = (state, ownProps) => {
  const eventId = ownProps?.match?.eventId
  const suiteUuids = keys(getSelectedSuites(state))
  const getDisplaySuite = makeGetDisplaySuite()
  const suites = map(suiteUuids, (suiteId) => getDisplaySuite(state, eventId, suiteId))
  const selectedSuiteUuids = map(suites, suite => suite.rvcUuid).sort()

  const customerDefaultPrefernces = state?.customerOrderingPreference?.defaultsByCustomerId ?? {}
  let preferredCustomerUuids = []

    forIn(customerDefaultPrefernces, (preferences, customerUuid) => {
      const commonUuids = intersection(keys(preferences), selectedSuiteUuids)
      if (isEqual(commonUuids.sort(), selectedSuiteUuids)) {
        preferredCustomerUuids.push(customerUuid)
      }
    })

  return map(preferredCustomerUuids, preferredCustomerUuid => getCustomer(state, preferredCustomerUuid))

}

export const makeGetCustomerDefaultPreferences = () => createSelector(
  [getCustomerDefaultPreferences], customerDefaultPreferences => customerDefaultPreferences
)

export const getToggles = (state) => get(state, 'customer.toggle', {})

export const getCustomerDefaultPreferenceUuids = state => keys(state?.customerOrderingPreference?.defaultsByCustomerId) ?? []

export const getIsCustomerLoading = state => state?.customer?.isLoading ?? false

export const getSearchCustomerValue = state => state?.customer?.searchCustomerValue ?? ''
